import { APP_CURRENCY, APP_LOCALE } from "../../../config/locale";
import type { FinancialStatus } from "../../../obras/obrasApi";

export const formatCurrency = (value?: number | null): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  return new Intl.NumberFormat(APP_LOCALE, { style: "currency", currency: APP_CURRENCY }).format(value).replace(/\./g, " ");
};

export const formatPercent = (value?: number | null): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  return `${value.toLocaleString(APP_LOCALE, { maximumFractionDigits: 2 })}%`;
};

export const statusLabel = (status: FinancialStatus): string => {
  if (status === "Healthy") return "Saudável";
  if (status === "Attention") return "Atenção";
  if (status === "Critical") return "Crítico";
  return "Sem dados";
};

export const statusClass = (status: FinancialStatus): string => {
  if (status === "Critical") return "bg-destructive/10 text-destructive border-destructive/30";
  if (status === "Attention") return "bg-amber-500/10 text-amber-700 border-amber-500/30";
  if (status === "Healthy") return "bg-emerald-500/10 text-emerald-700 border-emerald-500/30";
  return "bg-muted text-muted-foreground border-border";
};

export function FinancialStatusBadge({ status }: { status: FinancialStatus }) {
  return <span className={`inline-flex px-2 py-1 border text-xs ${statusClass(status)}`}>{statusLabel(status)}</span>;
}

export function FinancialKpiCard({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <div className="bg-card border border-border p-4" style={{ borderRadius: "var(--radius-card)" }}>
      <div className="text-secondary-text text-sm mb-2">{label}</div>
      <div className="text-foreground" style={{ fontSize: "var(--text-h3)", fontWeight: "var(--font-weight-semi-bold)" }}>{value}</div>
      {hint && <div className="text-secondary-text text-xs mt-2">{hint}</div>}
    </div>
  );
}
